import { render, staticRenderFns } from "./SubHeaderButtons.vue?vue&type=template&id=afcb0ba2&scoped=true"
import script from "./SubHeaderButtons.vue?vue&type=script&lang=js"
export * from "./SubHeaderButtons.vue?vue&type=script&lang=js"
import style0 from "./SubHeaderButtons.vue?vue&type=style&index=0&id=afcb0ba2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "afcb0ba2",
  null
  
)

export default component.exports